import clsx from 'clsx'

import { createCostObject } from 'helpers/global.helper/global.helper'

export type KpiValueProps = {
  value: string | number | Date | null | undefined
  unit?: string
  label: string
  tooltip?: string
  marginTop?: boolean
  marginRight?: boolean
  marginBottom?: boolean
  decimals?: number
  width?: string
  size?: 'small' | 'medium' | 'large'
  kind?: 'failed' | 'error' | 'warning' | 'success' | 'unknown' | 'running'
}

export default function KpiValue({
  value,
  label,
  unit,
  tooltip,
  marginTop,
  marginRight,
  marginBottom,
  decimals = 2,
  size = 'medium',
  width,
  kind,
}: KpiValueProps): React.JSX.Element {
  let prettyValue = value

  if (value === undefined || value === null) {
    prettyValue = '-'
  } else if (prettyValue instanceof Date) {
    prettyValue = prettyValue.toLocaleString('se-SE')
  } else if (typeof prettyValue === 'number') {
    const prettyObj = createCostObject(prettyValue, decimals, '')

    prettyValue = prettyObj.value + prettyObj.unit
  }

  return (
    <div
      className={clsx('flex flex-col', {
        'pr-3': marginRight,
        'mb-3': marginBottom,
        'mt-3': marginTop,
        [width || '']: !!width,
      })}
      title={tooltip}
    >
      <div
        className={clsx({
          'text-sm': size === 'small',
          'text-xl': size === 'medium',
          'text-2xl': size === 'large',
          'text-black': !kind && (size === 'medium' || size === 'large'),
          'text-gray-500': !kind && size === 'small',
          'text-red-400': kind === 'error' || kind === 'failed',
          'text-yellow-400': kind === 'warning',
          'text-green-400': kind === 'success',
          'text-blue-400': kind === 'running',
        })}
      >
        {prettyValue}

        {!!unit && <span className="ml-1 text-xs text-gray-600">{unit}</span>}
      </div>
      <div
        className={clsx({
          'text-xs text-gray-600': size === 'small',
          'text-sm text-gray-600': size === 'medium',
          'text-md text-gray-600': size === 'large',
        })}
      >
        {label}
      </div>
    </div>
  )
}
